import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeMetadata = {
  '/': {
    title: 'SDI Tecnologia | Soluções estratégicas em TI',
    description: 'Soluções estratégicas em TI, infraestrutura, suporte e segurança para empresas em todo o Brasil.'
  },
  '/servicos': {
    title: 'Serviços de TI | SDI Tecnologia',
    description: 'Conheça as soluções da SDI em suporte, service desk, field service, cibersegurança e desenvolvimento.'
  },
  '/sobre': {
    title: 'Sobre a SDI | SDI Tecnologia',
    description: 'Conheça a atuação, os valores e a experiência da SDI Tecnologia.'
  },
  '/contato': {
    title: 'Contato | SDI Tecnologia',
    description: 'Entre em contato com a equipe da SDI Tecnologia.'
  },
  '/historia': {
    title: 'Nossa história | SDI Tecnologia',
    description: 'Conheça a trajetória da SDI Tecnologia desde sua fundação.'
  },
  '/multiservicos': {
    title: 'Multisserviços | SDI Tecnologia',
    description: 'Soluções integradas de tecnologia, telecomunicações e infraestrutura em um único fornecedor.'
  },
  '/resultados': {
    title: 'Resultados | SDI Tecnologia',
    description: 'Veja indicadores de experiência, estrutura e alcance da SDI Tecnologia.'
  },
  '/compromisso': {
    title: 'Nosso compromisso | SDI Tecnologia',
    description: 'Conheça os compromissos sociais, ambientais e de saúde da SDI Tecnologia.'
  }
};

const RouteEffects = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = routeMetadata[pathname] || {
      title: 'Página não encontrada | SDI Tecnologia',
      description: 'A página solicitada não foi encontrada.'
    };

    document.title = metadata.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute('content', metadata.description);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default RouteEffects;
